import { FormTemplate } from "@/Common/Models/Forms/FormTemplate";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";
import { SectionRenderer } from "./SectionRenderer";

class TemplateFormRenderer {
    private sectionRenderers: SectionRenderer[];

    constructor(answers: QuestionnaireAnswer[], formTemplate: FormTemplate) {
        let sortedSections = formTemplate.Sections.sortByProperty(x => x.Position);

        this.sectionRenderers = sortedSections.map(section => new SectionRenderer(section, answers));
    }

    public isValid(): boolean {
        return this.sectionRenderers.all(x => x.isValid());
    }

    public render(onChange?: (answer: QuestionnaireAnswer) => void, disabled: boolean = false): JSX.Element {
        return (
            <div>
                {this.sectionRenderers.map(element => element.render(onChange, disabled))}
            </div>
        );
    }
}

export { TemplateFormRenderer };
